// extracted by mini-css-extract-plugin
module.exports = {"linkedIn_login_button":"styles_linkedIn_login_button__3zfst","linkedIn_logo_icon":"styles_linkedIn_logo_icon__1T8YH"};